import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'remixicon/fonts/remixicon.css'
import './assets/tailwind.css'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import { useSessionStore } from '@/stores/session'
import noRightClick from './directives/noRightClick';

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(router)
app.use(head)
app.directive('no-right-click', noRightClick);

const session = useSessionStore()
session.loadUser()

app.mount('#app')
